<template>
  <a-modal :visible="visible" title="新增">
    <a-form :form="form">
      <a-form-item
        label="机构名称"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'deptName',
            { rules: [{ required: true, message: '请填写机构名称' }] }
          ]"
          placeholder="请填写机构名称"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="上级部门"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-tree-select
          v-decorator="['parentId']"
          :replaceFields="{
            title: 'title',
            key: 'key',
            value: 'key',
            children: 'children'
          }"
          style="width:100%"
          :treeData="treeData"
        >
        </a-tree-select>
      </a-form-item>
      <a-form-item
        label="机构编码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'deptCode',
            { rules: [{ required: true, message: '请填写机构编码' }] }
          ]"
          placeholder="请填写机构编码"
        ></a-input>
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        @click="handleOk"
      >
        提交
      </a-button>
      <a-button key="back" @click="handleCancel">
        取消
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { findAllDepts, save } from "@/api/system/dept";

export default {
  data() {
    return {
      id: undefined,
      visible: false,
      form: this.$form.createForm(this),
      labelCol: { lg: { span: 5 }, sm: { span: 24 } },
      wrapperCol: { lg: { span: 15 }, sm: { span: 24 } },
      loading: false,
      treeData: []
    };
  },
  methods: {
    initTree() {
      findAllDepts().then(res => {
        this.treeData = res.result;
      });
    },
    openDrawer() {
      this.initTree();
      this.visible = true;
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          let params = Object.assign({ id: this.id }, values);
          save({ ...params }).then(res => {
            this.$emit("ok", res.message);
            this.loading = false;
            this.handleCancel();
          });
        }
      });
    },
    handleCancel() {
      this.form.resetFields();
      this.visible = false;
    }
  }
};
</script>

<style></style>
